import { useFormikContext, getIn } from 'formik';

import { IFormValues } from '../../DealRentModal';

export const useFieldHasErrors = (name: keyof IFormValues) => {
  const { touched, errors } = useFormikContext<IFormValues>();

  return Boolean(getIn(touched, name) && getIn(errors, name));
};
